<?xml version="1.0" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
 "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="280.000000pt" height="280.000000pt" viewBox="0 0 280.000000 280.000000"
 preserveAspectRatio="xMidYMid meet">
<metadata>
Created by potrace 1.14, written by Peter Selinger 2001-2017
</metadata>
<g transform="translate(0.000000,280.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M95 2786 c-41 -18 -83 -69 -90 -109 -3 -18 -4 -604 -3 -1304 3 -1266
3 -1272 24 -1299 11 -15 33 -37 48 -48 27 -21 30 -21 1326 -21 1296 0 1299 0
1326 21 15 11 37 33 48 48 21 27 21 30 21 1326 0 1296 0 1299 -21 1326 -11 15
-33 37 -48 48 -27 21 -32 21 -1314 23 -1055 2 -1293 0 -1317 -11z m1575 -722
c98 -29 181 -101 224 -193 30 -66 30 -206 -1 -273 -30 -66 -105 -143 -172
-175 -49 -24 -68 -28 -147 -28 -82 0 -96 3 -156 33 l-66 34 -58 -39 -59 -39
-3 -337 -2 -337 262 -2 c226 -3 263 -5 263 -18 0 -13 -55 -15 -427 -18 -423
-2 -428 -2 -428 18 0 16 7 20 35 20 28 0 52 13 110 56 41 31 75 62 75 68 0 6
-20 40 -43 76 -47 70 -157 258 -157 268 0 3 -7 13 -16 23 -14 16 -13 21 22 61
21 23 103 109 182 189 l145 147 -13 52 c-62 257 179 489 430 414z"/>
<path d="M1132 1320 c-35 -22 -89 -53 -121 -69 -89 -45 -89 -48 -40 -133 23
-40 71 -119 106 -175 43 -68 63 -108 59 -120 -4 -10 -34 -38 -69 -63 l-62 -45
94 -3 c51 -1 95 -1 97 1 3 2 3 149 2 326 l-3 322 -63 -41z"/>
</g>
</svg>
